// 차트 공통 스타일 헬퍼(2026-07-18) — "마지막 지점 점": 사람 눈은 라인을 왼쪽→오른쪽으로
// 따라가다 최신 값에서 멈추므로, 끝점에만 흰 테두리 점을 찍어 "지금 어디까지 왔나"가
// 바로 보이게 한다. 중간 지점들은 점 없이(라인만) 유지 — 구슬 노이즈 방지.
// Recharts 의 dot prop 은 함수를 받아 지점마다 호출한다. null 대신 r=0 원을 돌려주는
// 이유: 일부 버전에서 null 반환 시 콘솔 경고가 나서.
export function endpointDot(color, length) {
  const lastIdx = length - 1;
  return function EndDot(props) {
    const { cx, cy, index } = props;
    return (
      <circle
        key={`end-${index}`}
        cx={cx}
        cy={cy}
        r={index === lastIdx ? 3.5 : 0}
        fill={color}
        stroke="#fff"
        strokeWidth={1.5}
      />
    );
  };
}
